(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-localization-dialog]');
    if (!dialog || !dialog.showModal) return;
    const form = dialog.querySelector('form');
    const country = form.elements.country_code;
    const language = form.elements.language_code;
    country.querySelectorAll('option').forEach(option => {
      if (/^[A-Z]{2}$/.test(option.value)) {
        const flag = String.fromCodePoint(...[...option.value].map(letter => 127397 + letter.charCodeAt(0)));
        option.textContent = flag + '  ' + option.textContent;
      }
    });
    const storageKey = 'stone-roots-localization-v1';
    const preview = ['localhost', '127.0.0.1'].includes(location.hostname);
    // Match the existing header's local preview access to unpublished Slovenian.
    if (preview && ![...language.options].some(option => option.value === 'sl')) {
      language.add(new Option('Slovenščina', 'sl'));
    }
    language.value = dialog.dataset.language;
    function remembered() {
      try { return Number(localStorage.getItem(storageKey)) > Date.now(); } catch { return false; }
    }
    function remember() {
      try { localStorage.setItem(storageKey, String(Date.now() + 180 * 86400000)); } catch {}
    }
    function show() {
      if (document.querySelector('dialog[open]')) return;
      dialog.querySelector('[data-localization-error]').hidden = true;
      dialog.showModal();
      dialog.querySelector('#StoreLocalizationTitle').focus({ preventScroll: true });
      document.documentElement.classList.add('localization-dialog-open');
      document.documentElement.dataset.localizationPromptShown = 'true';
    }
    function dismiss() { remember(); dialog.close(); }
    dialog.querySelectorAll('[data-localization-dismiss]').forEach(button => button.addEventListener('click', dismiss));
    dialog.addEventListener('cancel', () => remember());
    dialog.addEventListener('close', () => document.documentElement.classList.remove('localization-dialog-open'));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss(); } });
    form.elements.return_to.value = location.pathname + location.search + location.hash;
    form.addEventListener('submit', async event => {
      if (!preview) {
        remember();
        return;
      }
      event.preventDefault();
      const error = dialog.querySelector('[data-localization-error]');
      const submit = form.querySelector('[type="submit"]');
      error.hidden = true;
      const path = location.pathname.replace(/^\/sl(?=\/|$)/, '') || '/';
      const destination = (language.value === 'sl' ? '/sl' : '') + path + location.search + location.hash;
      if (country.value === dialog.dataset.country) {
        remember();
        if (destination === location.pathname + location.search + location.hash) dialog.close();
        else location.assign(destination);
        return;
      }
      submit.disabled = true;
      try {
        const data = new FormData(form);
        // Slovenian can be previewed locally even while it is unpublished in Shopify.
        data.set('language_code', 'en');
        const response = await fetch(form.action, { method: 'POST', body: data, credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
        if (!response.ok) throw new Error('Localization request failed');
        remember();
        location.assign(destination);
      } catch {
        error.hidden = false;
      } finally {
        submit.disabled = false;
      }
    });
    document.querySelectorAll('[data-localization-open]').forEach(trigger => { trigger.hidden = false; });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-localization-open]');
      if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      country.value = dialog.dataset.country;
      language.value = dialog.dataset.language;
      show();
    });
    async function recommend() {
      if (window.Shopify?.designMode || remembered()) return;
      let suggestion;
      let detectedCountry;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { signal: AbortSignal.timeout(4000) });
        if (response.ok) { const result = await response.json(); suggestion = result.suggestions?.[0]?.parts; detectedCountry = result.detected_values?.country?.handle; }
      } catch {}
      const countryCode = suggestion?.country?.handle || detectedCountry;
      if ([...country.options].some(option => option.value === countryCode)) country.value = countryCode;
      const supported = [...language.options].map(option => option.value);
      const preferred = (navigator.languages || [navigator.language]).map(code => code.toLowerCase().split('-')[0]).find(code => supported.includes(code));
      const suggestedLanguage = preferred || suggestion?.language?.handle || (supported.includes('en') ? 'en' : dialog.dataset.language);
      if (supported.includes(suggestedLanguage)) language.value = suggestedLanguage;
      if (country.value !== dialog.dataset.country || language.value !== dialog.dataset.language) show();
    }
    recommend();
  })();
  } catch(e) { console.error(e); }
})();

})();
